import {
	createFunctionLibrary,
	buildDeepStructure,
	flattenStructure,
	getRequestedPageCompId,
} from '@wix/thunderbolt-becky-root'
import type { BeckyRequestPayload, SiteAssetsModule } from '@wix/thunderbolt-becky-root'
import { resolveBeckyModel } from '../siteAssetsModules/helpers/resolveBeckyModel'
import { resolveCommonAspects } from './resolveCommonAspects'
import { getBeckyTopology } from '../siteAssetsModules/helpers/topologyBuilder'
import { BeckyFetch } from '../siteAssetsModules/utils/beckyFetch'
import schemas from '@wix/document-services-json-schemas/dist/refData.json'
import _ from 'lodash'

const byRefModule: SiteAssetsModule<BeckyRequestPayload> = (moduleContext) => {
	const { httpClient, metricsReporter, topologyGetter, logger } = moduleContext
	const fetchFn = BeckyFetch(httpClient.fetch, metricsReporter, logger)
	const functionLibrary = createFunctionLibrary({
		fetch: fetchFn,
		metricsReporter,
		schemas,
	})

	async function execute(payload: BeckyRequestPayload) {
		const { pages } = payload

		const beckyModel = await functionLibrary.runAsyncAndReport(
			() =>
				resolveBeckyModel({
					payload,
					beckyTopology: getBeckyTopology(topologyGetter, payload),
					fetchFn,
					metricsReporter,
					logger,
				}),
			'resolveBeckyModel'
		)

		const masterPage = await pages.masterPage

		return functionLibrary
			.runAsyncAndReport(
				() =>
					resolveCommonAspects(
						beckyModel,
						flattenStructure(masterPage.structure, payload.viewMode === 'mobile', masterPage.data.slots),
						masterPage.data,
						functionLibrary,
						payload,
						schemas,
						logger
					),
				'resolveCommonAspects'
			)

			.then(async ({ structure, data, translations, seoTranslations, nicknameToCompIdMaps }) => {
				return functionLibrary.runAsyncAndReport(async () => {
					const requestedPageCompId = getRequestedPageCompId(pages)
					const currentPage = await pages[requestedPageCompId]
					const structureEntryPoint =
						structure[requestedPageCompId] ??
						_.find(structure, (comp) => comp.componentType.includes('AppWidget'))

					pages[requestedPageCompId] = Promise.resolve({
						...currentPage,
						data,
						translations,
						structure: buildDeepStructure(structureEntryPoint, structure),
					})
					// @ts-ignore
					payload.seoTranslations = seoTranslations
					payload.nicknameToCompIdMaps = nicknameToCompIdMaps

					return payload
				}, 'resolve-byref-payload')
			})
	}

	return {
		execute: (payload) => metricsReporter.runAsyncAndReport(() => execute(payload), 'tb-byref-module'),
	}
}

export default byRefModule
